<div class="trial-link-voice">
  <gdp-trial-link-form
  (emitFormValues)="generateLink($event)"
  ></gdp-trial-link-form>
</div>

<ng-template #trialVoiceLinkPopup let-modal>
  <gdp-copy-feedback-popup
    [title]="'sales.copy-trial-link-modal.title' | translate"
    [feedback]="'sales.copy-trial-link-modal.link-copied' | translate"
    [content]="modalContent">
    <div class="link-container">
      <a [href]="modalContent" target="_blank" class="link">{{modalContent}}</a>
    </div>
  </gdp-copy-feedback-popup>
</ng-template>
